module.exports = __webpack_public_path__ + "static/media/Phone-black.50ab1054.svg";